import { useState, useEffect } from 'react';
import Button from '@components/Button';
import Icon from '@material-ui/core/Icon';
import Table from '@components/Table';
import TextField from '@components/TextField';
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { format, isValid } from 'date-fns';
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';
import ChooseProductModal from './product/ChooseProductModal';
import { apiClient } from '@services/api';
import SelectSearch from 'react-select';
import { darkSelectStyles } from '@utils/darkSelectStyles';
import useIsNarrow from '@utils/useIsNarrow';

const Approves = (props) => {
  document.title = `Aprovações de desconto - ${process.env.REACT_APP_NAME}`

  const history  = useHistory();
  const narrow   = useIsNarrow();
  const [rows]   = useState([]);
  const [sellers, setSellers] = useState([]);
  const [reservationsStats, setReservationsStats] = useState([]);
  const [q, setQ] = useState(null);
  const [v, setV] = useState('');

  const getSellers = () => {
    apiClient.httpInstance.get(`/users?seller=true&status=true&pageSize=500`).then(response => {
      if (response.status === 200) {
        let options = [{ value: '', label: 'Todos' }];
        response.data.data.forEach((el) => options.push({ value: el.name, label: el.name }));
        setSellers(options);
      }
    }).catch(() => {});
  };

  const getReservationsStats = () => {
    apiClient.httpInstance.get(`/reservations_stats`).then(response => {
      if (response.status === 200) setReservationsStats(response.data);
    }).catch(() => {});
  };

  useEffect(() => {
    getSellers();
    getReservationsStats();
  }, []);

  // Oculta menu lateral
  useEffect(() => { props.setShowMenu(false); }, []);

  const typeProduct = {
    tour:           { bg: '#D8212FCC', text: 'Passeio' },
    translate:      { bg: '#4480A8E5', text: 'Traslado' },
    'translate-out':{ bg: '#4480A8E5', text: 'Out' },
    'translate-in': { bg: '#009C86E5', text: 'In' },
  };

  const discountStatusLabel = {
    pending:  { text: 'Aguardando aprovação', color: '#F5C842' },
    approved: { text: 'Aprovado',             color: '#62DEC2' },
    refused:  { text: 'Recusado',             color: '#e05252' },
    open:     { text: 'Em aberto',            color: '#8ba5c4' },
    sold:     { text: 'Convertido',           color: '#62DEC2' },
    canceled: { text: 'Cancelado',            color: '#8ba5c4' },
  };

  return (
    <>
      <div className="px-7">
        {/* Header */}
        <div
          className="flex items-center justify-between mt-2 text-2xl mb-3"
          style={{ color: '#e8f0fb' }}
        >
          <div className="flex items-center">
            <Icon className="mr-2" style={{ color: '#F5C842' }}>
              pending_actions
            </Icon>
            <span>Aprovações de desconto</span>
          </div>
        </div>

        {/* Filtros */}
        <div
          className="p-4 mt-4 border-1"
          style={{
            background: '#172B4D',
            borderRadius: '10px 10px 0px 0px',
            borderColor: '#1e3a5a',
          }}
        >
          <div className="flex flex-wrap items-center" style={{ gap: 12 }}>
            <div style={{ flex: narrow ? '1 1 100%' : '0 0 auto' }}>
              <TextField
                className="inputRounded"
                label="Busque por referência ou cliente"
                width={narrow ? '100%' : '280px'}
                variant="outlined"
                type="text"
                name="q"
                onChange={(ev) => setQ(ev.target.value)}
                InputProps={{ style: { color: '#e8f0fb', background: '#172B4D' } }}
                InputLabelProps={{ style: { color: '#8ba5c4' } }}
              />
            </div>
            <div
              style={{
                borderRadius: '20px', border: '1px solid #1e3a5a', padding: '9px 0px',
                flex: narrow ? '1 1 100%' : '0 0 auto', minWidth: narrow ? 0 : 220,
              }}
            >
              <SelectSearch
                styles={customStyles}
                options={sellers}
                width={narrow ? '100%' : '280px'}
                value={v === '' ? { name: 'Vendedor', label: 'Vendedor' } : { name: v, label: v }}
                onChange={(ev) => setV(ev.value)}
                name="seller"
              />
            </div>
          </div>
        </div>

        {/* Tabela */}
        <Table
          path="/budgets"
          params={{ q, v, to_approve: true }}
          onRowClick={(p) => {
            const id = p.id ?? p.row?.id ?? p.row?.presale_id;
            history.push(`/admin/aprovacoes/detalhe/${id}`);
          }}
          /* Celular/tablet: card com TODOS os dados de decisão à vista — aqui o
             uso é analisar para aprovar ou recusar, então nada fica escondido
             atrás de toque (inclusive a justificativa inteira). (2026-08) */
          renderMobileCard={(row) => {
            const typeLabel = {
              discount_pct:   (val) => `${val}% de desconto`,
              discount_value: (val) => `R$ ${val} de desconto`,
              installment:    (val) => `${val}x sem juros`,
            };
            let pedido = '—';
            if (row.approval_type && row.approval_value) {
              const fn = typeLabel[row.approval_type];
              pedido = fn ? fn(row.approval_value) : row.approval_value;
            } else if (row.discount_total_sale) {
              pedido = `${Number(row.discount_total_sale).toFixed(0)}% de desconto`;
            }

            let rowCurrent = '';
            reservationsStats.forEach((item) => {
              if (row.presale_id === item.presale_id) rowCurrent = item.total;
            });
            const typesArray = Array.from(new Set((rowCurrent || '').split(', ')));

            const approvalLabel = {
              pending:  { text: 'Gerencial pendente', color: '#F5C842' },
              approved: { text: 'Gerencial aprovado', color: '#62DEC2' },
              refused:  { text: 'Gerencial recusado', color: '#e05252' },
            };
            const info = row.approval_status
              ? approvalLabel[row.approval_status]
              : discountStatusLabel[row.status_discount_approve];

            const justify = row.approval_justify || row.justify_discount;

            return (
              <div style={{ padding: '14px', borderBottom: '1px solid #1e3a5a', cursor: 'pointer' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#8ba5c4', fontSize: 12, fontFamily: 'monospace' }}>
                    {row.status === 'canceled' && <Icon className="text-red-500" style={{ fontSize: 14 }}>block</Icon>}
                    {row.references}
                  </span>
                  {info && (
                    <span style={{
                      color: info.color, border: `1px solid ${info.color}`, borderRadius: 20,
                      padding: '2px 9px', fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap',
                    }}>{info.text}</span>
                  )}
                </div>

                <div style={{ fontSize: 15, color: '#e8f0fb', fontWeight: 600, margin: '4px 0 8px' }}>
                  {row.customer_name}
                </div>

                {(typesArray.some(t => typeProduct[t]) || row.has_combo) && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 8 }}>
                    {typesArray.map((type, idx) => typeProduct[type] ? (
                      <span key={idx} style={{
                        background: typeProduct[type].bg, color: '#fff', borderRadius: 20,
                        padding: '2px 10px', fontSize: 11, fontWeight: 700,
                      }}>{typeProduct[type].text}</span>
                    ) : null)}
                    {row.has_combo && <span style={{ color: '#e8f0fb', fontSize: 12 }}>Combo</span>}
                  </div>
                )}

                <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginBottom: justify ? 8 : 0 }}>
                  <div>
                    <div style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase' }}>Pedido</div>
                    <div style={{ fontSize: 15, color: '#F5C842', fontWeight: 700 }}>{pedido}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase' }}>Valor do orçamento</div>
                    <NumberFormat
                      value={Number(row.total)}
                      displayType="text"
                      decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString
                      prefix={`${process.env.REACT_APP_CURRENCY} `}
                      renderText={(value) => <div style={{ fontSize: 15, color: '#e8f0fb', fontWeight: 600 }}>{value}</div>}
                    />
                  </div>
                </div>

                {justify && (
                  <div style={{
                    background: 'rgba(255,255,255,0.04)', borderRadius: 8, padding: '8px 10px',
                    fontSize: 12, color: '#c3d3e6', lineHeight: 1.5, marginBottom: 8,
                  }}>
                    <span style={{ color: '#64748b', fontWeight: 700 }}>Justificativa: </span>{justify}
                  </div>
                )}

                <div style={{ fontSize: 11, color: '#64748b' }}>{row.user_name}</div>
              </div>
            );
          }}
          columns={[
            {
              headerName: 'Referência',
              headerClassName: 'super-app-theme--header',
              field: 'references',
              flex: 1,
              minWidth: 120,
              renderCell: (params) => {
                const row = params.row;
                return (
                  <div className="flex items-center" style={{ gap: 8 }}>
                    {row.status === 'canceled' && (
                      <Icon className="text-red-500" style={{ fontSize: 16 }}>block</Icon>
                    )}
                    <span style={{ color: '#e8f0fb', fontWeight: 600 }}>{row.references}</span>
                  </div>
                );
              },
            },
            {
              headerName: 'Cliente',
              headerClassName: 'super-app-theme--header',
              field: 'customer_name',
              flex: 2,
              minWidth: 150,
            },
            {
              headerName: 'Tipo',
              headerClassName: 'super-app-theme--header',
              field: 'types',
              flex: 1,
              minWidth: 110,
              renderCell: (params) => {
                const row = params.row;
                let rowCurrent = '';
                reservationsStats.forEach((item) => {
                  if (row.presale_id === item.presale_id) rowCurrent = item.total;
                });
                const typesArray = Array.from(new Set((rowCurrent || '').split(', ')));
                return (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {typesArray.map((type, idx) => {
                      if (typeProduct[type]) {
                        return (
                          <span
                            key={idx}
                            style={{
                              background: typeProduct[type].bg,
                              color: '#fff',
                              borderRadius: 20,
                              padding: '2px 10px',
                              fontSize: 11,
                              fontWeight: 700,
                            }}
                          >
                            {typeProduct[type].text}
                          </span>
                        );
                      }
                      return null;
                    })}
                    {row.has_combo && (
                      <span style={{ color: '#e8f0fb', fontSize: 12 }}>Combo</span>
                    )}
                  </div>
                );
              },
            },
            {
              headerName: 'Pedido',
              headerClassName: 'super-app-theme--header',
              field: 'approval_value',
              flex: 1,
              minWidth: 110,
              renderCell: (params) => {
                const row = params.row;
                const typeLabel = {
                  discount_pct:   (v) => `${v}% desc.`,
                  discount_value: (v) => `R$ ${v} desc.`,
                  installment:    (v) => `${v}x s/j`,
                };
                if (row.approval_type && row.approval_value) {
                  const fn = typeLabel[row.approval_type];
                  return <span style={{ color: '#F5C842', fontWeight: 700, fontSize: 13 }}>{fn ? fn(row.approval_value) : row.approval_value}</span>;
                }
                if (row.discount_total_sale) {
                  return <span style={{ color: '#F5C842', fontWeight: 700, fontSize: 13 }}>{Number(row.discount_total_sale).toFixed(0)}%</span>;
                }
                return <span style={{ color: '#8ba5c4' }}>—</span>;
              },
            },
            {
              headerName: 'Valor',
              headerClassName: 'super-app-theme--header',
              field: 'total',
              flex: 1,
              minWidth: 110,
              renderCell: (params) => {
                const row = params.row;
                return (
                  <NumberFormat
                    value={Number(row.total)}
                    displayType="text"
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale
                    thousandSeparator="."
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => (
                      <span style={{ color: '#e8f0fb' }}>{value}</span>
                    )}
                  />
                );
              },
            },
            {
              headerName: 'Justificativa',
              headerClassName: 'super-app-theme--header',
              field: 'approval_justify',
              flex: 2,
              minWidth: 180,
              renderCell: (params) => {
                const row = params.row;
                const txt = row.approval_justify || row.justify_discount;
                return (
                  <span
                    title={txt}
                    style={{
                      color: '#8ba5c4',
                      fontSize: 12,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '100%',
                      display: 'block',
                    }}
                  >
                    {txt || '—'}
                  </span>
                );
              },
            },
            {
              headerName: 'Vendedor',
              headerClassName: 'super-app-theme--header',
              field: 'user_name',
              flex: 1,
              minWidth: 120,
            },
            {
              headerName: 'Status',
              headerClassName: 'super-app-theme--header',
              field: 'status_discount_approve',
              flex: 1,
              minWidth: 130,
              headerAlign: 'right',
              align: 'right',
              renderCell: (params) => {
                const row  = params.row;
                // Prioriza approval_status (gerencial) se presente
                const apSt = row.approval_status;
                const approvalLabel = {
                  pending:  { text: 'Gerencial pendente', color: '#F5C842' },
                  approved: { text: 'Gerencial aprovado', color: '#62DEC2' },
                  refused:  { text: 'Gerencial recusado', color: '#e05252' },
                };
                const info = apSt ? approvalLabel[apSt] : discountStatusLabel[row.status_discount_approve];
                return info ? (
                  <span
                    style={{
                      color: info.color,
                      fontWeight: 700,
                      fontSize: 12,
                      padding: '2px 10px',
                      borderRadius: 20,
                      border: `1px solid ${info.color}`,
                      display: 'inline-block',
                    }}
                  >
                    {info.text}
                  </span>
                ) : null;
              },
            },
          ]}
          rows={rows}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps)(Approves);

const customStyles = {
  ...darkSelectStyles,
  menu: (provided, state) => ({
    ...darkSelectStyles.menu(provided, state),
    width: state.selectProps.width,
  }),
  control: (provided, state) => ({
    ...darkSelectStyles.control(provided, state),
    width: state.selectProps.width,
  }),
};
